import { useCallback } from 'react';
import { useGlobalSearch } from '@atlassian/jira-software-global-search-tracker';

type Props = {
	onFocusSearch: () => void;
};

const HijackBrowserSearch = ({ onFocusSearch }: Props) => {
	const onGlobalSearch = useCallback(
		({ event }: { event: Event }) => {
			event.preventDefault();
			onFocusSearch();
		},
		[onFocusSearch],
	);

	useGlobalSearch(onGlobalSearch);

	return null;
};

export { KeyboardShortcutTooltip } from './ui';

export default HijackBrowserSearch;
